// extracted by mini-css-extract-plugin
export default {"root":"style_root__cyP2s","container":"style_container__YLIcs","shine":"style_shine__UG4Kl","placeholder":"style_placeholder__VmULj"};